import React from 'react'


export default function NotFound(){
    return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <h1>Not Found</h1>
    </div>
}